import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import i18n from '../../../utils/i18n';
import Navigation from '../../regFlow/components/navigation/navigation';
import RadioInput from '../../regFlow/components/searchInputs/radioInput';
import { vatFilterInput, vatInput } from '../data/kftRgFlowText';

const VatPayment = ({ handleNext, handleBack }) => {
  const companyStore = useSelector((state) => state.company_store);

  return (
    <div className='stepContainer'>
      <div className='SFInput'>
        <p className='SFSubTitle'>
          <span className='SFSubTitle'>
            {i18n.t('kftregflow.vatPaymentFilterText')}
          </span>{' '}
        </p>
        <RadioInput storeID="vatFilter" dataText={vatFilterInput()} />

        {companyStore.vatFilter === 'true' ? (
          <>
            <p className="SFSubTitle">{i18n.t('kftregflow.vatPaymentFrequencyText')}</p>
            <RadioInput storeID="vatPayment" dataText={vatInput()} />
          </>
        ) : (
          <></>
        )}
      </div>

      <Navigation
        step={2}
        handleBack={() => handleBack()}
        handleNext={() => handleNext()}
        disabledProp={companyStore.vatFilter === '' || (companyStore.vatFilter === 'true' && companyStore.vatPayment === '') ? true : false}
      />
    </div>
  );
};

export default withTranslation()(VatPayment);
